module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account--wrapper"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-push-4 col-md-4"
  }, [_c('div', {
    staticClass: "card ui-card form--account"
  }, [_c('H1', [_vm._v(_vm._s(_vm.locale.t('label_term_edit_term')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_day')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.day),
      expression: "model.day"
    }],
    staticClass: "form-control input",
    attrs: {
      "name": "uloga"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.model, "day", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "MONDAY",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.locale.t('day_monday')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TUESDAY"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('day_tuesday')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "WEDNESDAY"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('day_wednesday')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "THURSDAY"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('day_thursday')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "FRIDAY"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('day_friday')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SATURDAY"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('day_saturday')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SUNDAY"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('day_sunday')))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.trainingNumbers))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.maxTrainings),
      expression: "model.maxTrainings"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "placeholder": _vm.trainingNumbers,
      "name": "prezime"
    },
    domProps: {
      "value": (_vm.model.maxTrainings)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "maxTrainings", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_time')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.startAt),
      expression: "model.startAt"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": "HH:mm",
      "name": "treninzi"
    },
    domProps: {
      "value": (_vm.model.startAt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "startAt", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_training_type_title')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.trainingType),
      expression: "model.trainingType"
    }],
    staticClass: "form-control input",
    attrs: {
      "name": "uloga"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.model, "trainingType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.types), function(item, key) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v("\n                                                " + _vm._s(item) + "\n                                            ")])
  }), 0)])])])]), _vm._v(" "), (_vm.showAddTrainerToSlot) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_name_for_partner')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.trainerOnSlot),
      expression: "model.trainerOnSlot"
    }],
    staticClass: "form-control input",
    attrs: {
      "name": "uloga"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.model, "trainerOnSlot", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("\n                                  " + _vm._s("") + "\n                                ")]), _vm._v(" "), _vm._l((_vm.partners), function(item) {
    return _c('option', {
      domProps: {
        "value": item.name
      }
    }, [_vm._v("\n                                  " + _vm._s(item.name) + "\n                                ")])
  })], 2)])])])]) : _vm._e(), _vm._v(" "), (_vm.isVisibleAddUserToTerm) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group text-center"
  }, [_c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.showChoseUser()
      }
    }
  }, [_vm._v("+"), _c('i', {
    staticClass: "ti-user"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_term_add_user_to_term')) + "\n                            ")])])]), _vm._v(" "), (_vm.selectedUsers.length > 0) ? _c('div', {
    staticClass: "col-md-12"
  }, _vm._l((_vm.selectedUsers), function(selectedUser) {
    return _c('div', {
      staticClass: "form-group text-center"
    }, [_c('b', [_vm._v(_vm._s(selectedUser.name) + " " + _vm._s(selectedUser.surname) + " (" + _vm._s(selectedUser.username) + ")")]), _vm._v(" " + _vm._s(_vm.locale.t('label_term_user_will_be_added')) + " "), _c('i', {
      staticClass: "ti-trash",
      staticStyle: {
        "color": "#FF0000",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.removeSelectedUser(selectedUser)
        }
      }
    })])
  }), 0) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group text-center"
  }, [_c('div', {
    staticClass: "new-button",
    on: {
      "click": _vm.editTerm
    }
  }, [_c('i', {
    staticClass: "ti-save"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_save')) + "\n                                    ")])])])])], 1)])])])]), _vm._v(" "), _c('choose-user-modal', {
    attrs: {
      "show": _vm.chooseUser
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-plus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-list"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-user"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-28ae591a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Term/Edit/EditTerm.vue
// module id = 743
// module chunks = 0